import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useD2DKnockEnabled() {
  const d2DKnockStatus = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.D2DKnockStatus),
  )

  return d2DKnockStatus?.enabled ?? false
}
